/* eslint-disable no-undef */
import React from 'react';
import PropTypes from 'prop-types';
import rentedImage from '../../../../../../assets/images/rented-out.png';
import newLocationImage from '../../../../../../assets/images/new-location-image.png';
import './MarkerContent.scss';

import { StarRateIcon } from '../../../SharedComponents/Icons';

const MarkerContent = props => (
  <div>
    <a className="marker-info__title" title={I18n.t('list_view.map.info_window.read_more_title')} href={props.link}>
      {props.heading}
    </a>

    <div className="markerblock-wrapper">
      <div className="marker-image">
        <a title={props.heading} href={props.link}>
          <img src={props.imageUrl} alt="location marker" />
          {props.state === 'closed' && (
            <img
              className="rented-image"
              src={rentedImage}
              alt="rented out"
            />
          )}
          {props.showNewBadge && (
            <img
              className="new-location-image"
              src={newLocationImage}
              alt="new location"
            />
          )}
        </a>
      </div>
      <div className="marker-info">
        <p>
          {I18n.t('list_view.map.info_window.office_size')}
          {props.area}
        </p>
        <div className="marker-rating">
          <p>
            {I18n.t('list_view.map.info_window.standard')}
          </p>
          {[...Array(props.stars_rating)].map(elem => (
            <StarRateIcon key={elem} />
          ))}
        </div>
      </div>
    </div>
  </div>
);

MarkerContent.propTypes = {
  link: PropTypes.string,
  heading: PropTypes.string,
  imageUrl: PropTypes.string,
  area: PropTypes.string,
  state: PropTypes.string,
  showNewBadge: PropTypes.bool,
  stars_rating: PropTypes.number,
};

MarkerContent.defaultProps = {
  link: '',
  heading: '',
  imageUrl: '',
  area: '',
  state: '',
  showNewBadge: false,
  stars_rating: 4,
};


export default MarkerContent;
